
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-health-coaches",
      function () {
        return require("private-next-pages/for-health-coaches/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-health-coaches"])
      });
    }
  